var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 290,
    viewBox: "0 0 357 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.947 130.858C217.941 54.3521 204.79 115.364 135.71 43.6549L94.619 1L1 91.1866C1 91.1866 3.08095 94.4683 42.6238 134.395C105.275 197.67 133.587 157.676 195.908 220.608L261.589 288.789L355.643 198.183C355.643 198.183 292.07 133.062 289.947 130.858Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M297.306 199.656C298.172 199.573 298.959 199.565 299.727 199.411C302.03 198.965 304.08 197.666 305.467 195.774C306.036 195.127 306.398 194.325 306.508 193.47C306.618 192.615 306.469 191.747 306.082 190.976C305.31 189.457 304.146 188.173 302.709 187.257C298.803 184.671 294.739 182.331 290.542 180.25C284.551 177.146 278.512 174.118 272.521 171.014C269.134 169.276 265.865 167.319 262.733 165.154C260.721 163.855 259.067 162.069 257.927 159.962C257.272 158.629 256.964 157.152 257.03 155.669C257.095 154.186 257.534 152.743 258.304 151.474C258.835 150.467 258.868 150.766 258.192 150.08C256.143 147.954 254.087 145.82 252 143.73L251.617 143.333L257.517 137.65L257.885 138.031C260.032 140.167 262.18 142.303 264.312 144.455C264.515 144.665 264.677 144.614 264.955 144.436C266.596 143.191 268.508 142.352 270.536 141.989L272.065 148.655C271.111 149.019 270.142 149.291 269.24 149.725C267.968 150.348 266.9 151.319 266.161 152.526C265.762 153.092 265.535 153.761 265.509 154.452C265.483 155.144 265.658 155.828 266.013 156.423C266.818 157.709 267.931 158.774 269.252 159.52C274.54 162.772 279.996 165.742 285.597 168.419C291.439 171.367 297.273 174.307 303.012 177.384C305.478 178.719 307.85 180.223 310.11 181.885C312.469 183.517 314.222 185.884 315.094 188.617C315.464 189.917 315.566 191.278 315.394 192.618C315.222 193.958 314.78 195.249 314.095 196.413C313.842 196.897 313.852 197.173 314.198 197.5C316.414 199.676 318.606 201.874 320.806 204.08C321.009 204.29 321.204 204.493 321.422 204.719L315.452 210.47L308.218 202.961C307.23 203.492 306.286 204.071 305.283 204.587C303.636 205.388 301.882 205.95 300.076 206.254C300.011 206.257 299.946 206.248 299.885 206.227C299.829 206.192 299.783 206.144 299.75 206.087C298.908 204.014 298.122 201.873 297.306 199.656Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5029 93.5739L87.8075 43.187",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7783 114.62L97.2795 74.6407",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1211 135.738L121.724 91.8071",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.523 148.357L136.369 116.715",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.033 156.271L186.338 105.884",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M164.356 162.682L210.621 118.113",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189.992 177.425L225.897 142.837",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4);
export default __webpack_public_path__ + "static/media/img4.0ff2a5725a02aae4a43ae37be4a0402e.svg";
export { ForwardRef as ReactComponent };